export const annexureHeaderData = [
  {
    width: 150,
    title: "Part Number",
    field: "part_number",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 250,
    title: "Part Description",
    field: "part_description",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 100,
    title: "Part Weight",
    field: "part_weight",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 100,
    title: "Part Length",
    field: "part_length",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 100,
    title: "Part Width",
    field: "part_width",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 100,
    title: "Part Height",
    field: "part_height",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 150,
    title: "Annual Volume",
    field: "annual_volume",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 150,
    title: "TML Receiving Plant",
    field: "tml_receiving_plant",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 100,
    title: "Vendor Code",
    field: "vendor_code",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 150,
    title: "Vendor Name",
    field: "vendor_name",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 150,
    title: "Vendor Location",
    field: "vendor_location",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 150,
    title: "Packaging Length",
    field: "packaging_length",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 150,
    title: "Packaging Width",
    field: "packaging_width",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 150,
    title: "Packaging Height",
    field: "packaging_height",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 200,
    title: "Packaging Part Quantity",
    field: "packaging_part_quantity",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 200,
    title: "Packaging Gross Weight",
    field: "packaging_gross_weight",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 300,
    title: "Supplier Proposed Packaging Cost/Part",
    field: "supplier_proposed_packaging_cost",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 300,
    title: "Supplier Proposed Transportation Cost/Part",
    field: "supplier_proposed_transportation_cost",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 300,
    title: "TML Recommended	Packaging Cost/Part",
    field: "tml_recommended_packaging_cost",
    enableSearch: false,
    enableFilter: false,
  },
  {
    width: 300,
    title: "TML Recommended Transportation Cost/Part",
    field: "tml_recommended_transportation_cost",
    enableSearch: false,
    enableFilter: false,
  },
];
